import { string } from "yup";
import { MAX_COMMENT_LENGTH } from "./lengthConstants";

export const PostCommentSchema = string()
  .max(MAX_COMMENT_LENGTH)
  .min(1)
  .trim()
  .required();
